/**
 * Format a date string to DD/MM/YYYY format
 * Accepts ISO date strings (YYYY-MM-DD) or Date objects
 */
export function formatDate(date: string | Date): string {
  let dateObj: Date

  if (typeof date === 'string') {
    // Handle ISO date strings (YYYY-MM-DD)
    dateObj = new Date(date)
  } else {
    dateObj = date
  }

  const day = String(dateObj.getDate()).padStart(2, '0')
  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const year = dateObj.getFullYear()

  return `${day}/${month}/${year}`
}

/**
 * Convert DD/MM/YYYY to ISO date string (YYYY-MM-DD) for storage
 */
export function parseDate(dateStr: string): string {
  const parts = dateStr.split('/')
  if (parts.length !== 3) {
    throw new Error('Invalid date format. Expected DD/MM/YYYY')
  }

  const [day, month, year] = parts
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

/**
 * Convert DD/MM/YYYY to YYYY-MM-DD for HTML date inputs
 * Returns empty string if date is invalid
 */
export function toInputDate(dateStr: string): string {
  if (!dateStr) return ''

  try {
    // If already in ISO format (YYYY-MM-DD), return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr
    }

    // Convert DD/MM/YYYY to YYYY-MM-DD
    return parseDate(dateStr)
  } catch {
    return ''
  }
}

/**
 * Convert YYYY-MM-DD (from HTML date input) to DD/MM/YYYY for display
 * Returns empty string if date is invalid
 */
export function fromInputDate(dateStr: string): string {
  if (!dateStr) return ''

  try {
    // If already in display format (DD/MM/YYYY), return as is
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      return dateStr
    }

    // Convert YYYY-MM-DD to DD/MM/YYYY
    return formatDate(dateStr)
  } catch {
    return ''
  }
}
